import EventEmitter from 'eventemitter3';
import Dispatcher from '../core/Dispatcher';
import ActionTypes from '../constants/ActionTypes';
import Location from '../core/Location';

var CHANGE_EVENT = 'change';

class GalleryStore extends EventEmitter {
  constructor(params) {
    super(params);

    this._state = {
      uploads: [],
      last: null
    }
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  get() {
    return this._state;
  }

  append(data) {
    this._state.uploads = this._state.uploads.concat(data);
    this._state.last = data[data.length - 1].createdAt;

    this.emitChange();
  }
}

var galleryStore = new GalleryStore();
galleryStore.dispatchToken = Dispatcher.register(function(action) {
  switch (action.type) {
    case ActionTypes.GALLERY_GET_LAST: {
      if(galleryStore._state.uploads.length === 0) {
        const url = '/api/upload/last/' + action.n;

        $.ajax({type: 'GET', url: url})
        .success(function(data) {
          galleryStore.append(data);
        })
        .error(function(xhr, status, err) {
          // TODO: Error handling

          galleryStore.emitChange();
        });
      }
    } break;

    case ActionTypes.GALLERY_GET_MORE: {
      var self = this;
      const url = '/api/upload/more/' + action.n;// + '?last=' + galleryStore._state.last;
      const query = {
        last: galleryStore._state.last
      }

      $.ajax({type: 'GET', url: url, data: query})
      .success(function(data) {
        if(data.length > 0) {
          galleryStore.append(data);
        }
      })
      .error(function(xhr, status, err) {
        // TODO: Error handling

        galleryStore.emitChange();
      });

      galleryStore.emitChange();
    } break;

    default:
      // do nothing
  }
});

export default galleryStore;



/** WEBPACK FOOTER **
 ** ./src/stores/Gallery.js
 **/